import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {RecentlyReport} from "../model/report/recently-report";
import {environment} from "../../environments/environment";
import {ParamsBuildHelper} from "../helper/params-build-helper";
import {RecentSearch} from "../model/RecentSearch";
import {ProReportModel} from "../model/report/pro-reportmodel";

@Injectable({
  providedIn: 'root'
})
export class ReportService {

  constructor(private http: HttpClient) {

  }

  getRecentSearches(size: number, page: number): Observable<RecentSearch[]> {
    return this.http.get<RecentSearch[]>(environment.apiUrl + "/history/recent-search" + ParamsBuildHelper.buildGetParams(
      {
        'page': page.toString(),
        'size': size.toString(),
      }));
  }

  getRecentlyViewedReports(size: number, page: number): Observable<RecentlyReport[]> {
    return this.http.get<RecentlyReport[]>(environment.apiUrl + "/history/pro-report" + ParamsBuildHelper.buildGetParams(
      {
        'page': page.toString(),
        'size': size.toString(),
      }));
  }

  getObligorByid(obligorId: string): Observable<ProReportModel> {
    return this.http.get<ProReportModel>(environment.apiUrl + "/history/search" + ParamsBuildHelper.buildGetParams(
      {
        'obligorId': obligorId
      }));
  }

}
